// extracted by mini-css-extract-plugin
module.exports = {"button":"ProductAddToBag_button__2qqCZ","quantity":"ProductAddToBag_quantity__P2VRk"};